const initEvent = (event) => ({
  success: () => {},
  error: () => {},
  ...event
})

const initAction = (action, data) => ({
  start: () => ({
    type: action + '_STARTED'
  }),
  success: (result) => ({
    type: action + '_SUCCESS',
    result,
    data
  }),
  failure: (error) => ({
    type: action + '_FAILURE',
    error
  })
})

const xhr = ({api, ...param}) => {
  const data = param.data || undefined
  const event = initEvent(param.event)
  const action = initAction(param.action, param.data)
  // console.log(api.url)
  return (dispatch) => {
    dispatch(action.start())
    return fetch(api.url, {
      method: api.method,
      headers: new Headers({
        'X-Pear-Token': localStorage.getItem('ShadowFog_token')
      }),
      body: JSON.stringify(data)
    })
    .then((response) => {
      response.json().then((responseJson) => {
        switch (response.status) {
          case 200:
            dispatch(action.success(responseJson))
            event.success(responseJson)
            break
          default:
            dispatch(action.failure(responseJson))
            event.error(responseJson)
            break
        }
      }).catch((error) => {
        dispatch(action.failure(error))
        event.error(error)
      })
    })
    .catch((error) => {
      dispatch(action.failure(error))
      event.error(error)
    })
  }
}

export default xhr



// WEBPACK FOOTER //
// ./src/Xhr.js